import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faSignOutAlt, faBook } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../store/AuthContext";
import { Avatar } from "@mui/material";
import { useIsMobile } from "../helpers/useIsMobile";

const Topbar = () => {
  const { isSidebarCollapsed, setIsSidebarCollapsed, user, logout } = useAuth();
  const isMobile = useIsMobile();
  const effectiveCollapsed = isMobile || isSidebarCollapsed;
  const userName = user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
  const companyName = user["CompanyName"];

  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <nav
      className={`fixed top-0 right-0 z-40 bg-white border-b border-lightGray shadow-sm transition-all duration-300 ease-in-out py-2 px-4
      ${effectiveCollapsed ? 'left-0' : 'left-0 md:left-64'}`}
    >
      <div className="flex justify-between items-center h-full">
        {/* Left Side: Toggle & Company Info */}
        <div className="flex items-center gap-4">
          <button
            className="w-10 h-10 rounded-full flex items-center justify-center text-gray hover:text-primary hover:bg-primary/10 transition-all duration-200 active:scale-95"
            onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            aria-label="Toggle Sidebar"
          >
            <FontAwesomeIcon icon={faBars} className="text-lg" />
          </button>

          <div className="flex items-center">
            {process.env.REACT_APP_ENV === "Development" && (
              <span className="hidden md:inline-block px-2 py-1 mr-3 text-xs font-bold text-white bg-danger rounded-md shadow-sm uppercase tracking-wider">
                {isMobile ? "Dev" : "Development Mode"}
              </span>
            )}
            <div>
              <h5 className="text-base font-bold text-dark m-0 tracking-tight flex items-center bg-clip-text text-transparent bg-gradient-to-br from-primary to-accent">
                <FontAwesomeIcon icon={faBook} className="text-primary mr-2" />
                <span className="text-dark bg-clip-border">{companyName}</span>
              </h5>
              <h6 className="text-xs font-medium text-gray m-0">{userName}</h6>
            </div>
          </div>
        </div>

        {/* Right Side: User Menu */}
        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-3 p-1 pr-4 rounded-full border border-transparent hover:bg-light hover:border-lightGray hover:shadow transition-all duration-200 group"
          >
            <Avatar
              src={"sdgh"}
              alt={user.fullName}
              className="border-2 border-white shadow-[0_0_0_1px_#e2e8f0]"
              sx={{
                width: 40,
                height: 40,
                background: 'linear-gradient(135deg, #FE6D05 0%, #ea580c 100%)'
              }}
            />
            <div className="hidden lg:block text-left">
              <span className="block text-xs text-gray font-medium">Welcome,</span>
              <span className="block text-sm text-dark font-semibold group-hover:text-primary transition-colors">{userName}</span>
            </div>
          </button>

          {/* Dropdown Menu */}
          {showDropdown && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setShowDropdown(false)}></div>
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-lightGray py-1 overflow-hidden z-20 origin-top-right animate-in fade-in zoom-in-95 duration-200">
                <button
                  onClick={logout}
                  className="w-full text-left px-4 py-3 text-sm font-medium text-dark hover:bg-light hover:text-primary transition-colors flex items-center"
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger mr-2" />
                  Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Topbar;
